// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"594":"about","981":"form-view"}[chunkId] + "." + {"594":"1cd7e883","981":"005f9985"}[chunkId] + ".css";
};